import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { OnboardingService } from '../../onboarding.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDetailsService } from 'src/app/core/services/user-details/user-details.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-setup4',
  templateUrl: './setup4.component.html',
  styleUrls: ['./setup4.component.css']
})
export class Setup4Component implements OnInit {

  videoDuration;
  disableSubmitBtn: boolean;
  file1: any;
  userId: any;
  videoUrl: any;
  isReadMore = true
  isNetDivSmall = false;
  urlParam: any;
  userInfo: any;
  isUserLogin: boolean;
  UpdatedParam: any;
  router: any;
  setProfilePic: boolean;
  name: any;
  img: any;
  isDivSmall = true;
  title: any;
  url: string | ArrayBuffer;
  disableBack: boolean;
  iamVideo: any;
  iAmVideoId: any;



  constructor(private OnboardingService: OnboardingService, private service: UserDetailsService, private activeRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,protected readonly route: ActivatedRoute,
    protected readonly Router: Router
  ) { this.userId = activeRoute.snapshot.params.id; 
   this.iAmVideoId = activeRoute.snapshot.queryParams.iAmVideo; 
  }

  ngOnInit(): void {
this.disableBack =this.iAmVideoId == 'false'? false:true;
  
    this.OnboardingService.getShowcases().subscribe((res: any) => {

      this.OnboardingService.postSetupVisited(this.userId).subscribe((res)=>{
        this.OnboardingService.userDetails.isSetupVisited = true;
      }, err=>{

      })
    })
    this.urlParam = this.router?.url;

    this.UpdatedParam = this.urlParam?.slice(0);

    // console.log("param", this.urlParam)
    this.OnboardingService.getShowcases().subscribe((res: any) => {
      this.userInfo = res.user;
      console.log(this.userInfo)
      if (this.userInfo > 0)  //if(this.userInfo >= 0) to display profilepicture and username
      {
        this.isUserLogin = true;
        this.id = this.userInfo
        this.userDetails();

      }
      else {
        this.isUserLogin = false;
      }

    })
  }
  showText() {
    this.isReadMore = !this.isReadMore;
    this.isDivSmall = !this.isDivSmall;
  }
  onFileDetected(event) {
    console.log(event.target.files[0]);
    let file = event.target.files && event.target.files[0];
    let newFile = event.target.files[0];
    this.title = event.target.files[0].name;
    if (file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      this.videoUrl = file;
      console.log(this.videoUrl)
    }
    reader.onload = async (event) => {
      this.url = (<FileReader>event.target).result;
    }
    const inputVideo = event.target.files[0];
    const video = document.createElement('video');
    video.src = window.URL.createObjectURL(inputVideo);
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      console.log('video source', video.src);
      console.log('video length', video.duration);
      this.videoDuration = video.duration;
      if (event.target.files[0].size >= 943718400) {
        alert("File size is too big  ")

        this.disableSubmitBtn = false;
        this.videoUrl = '';
        this.title = '';

      }
      else if (this.videoDuration < 10) {
        this.disableSubmitBtn = false;
        this.videoUrl = '';
        this.title = '';
        alert("This video is too short. I AM VIDEO must be at least 10 seconds and no longer than 60 seconds. Please upload a video in this range.")
      }
      else if (this.videoDuration > 60) {
        this.disableSubmitBtn = false;
        this.videoUrl = '';
        this.title = '';
        alert("This video is too long. I AM VIDEO must be at least 10 seconds and no longer than 60 seconds. Please upload a video in this range.")
      }
      else {

        if (confirm('Video is getting uploaded. Please wait for few seconds!')) {
          this.submit();
        this.disableSubmitBtn = true;
        this.spinner.show()
        } else {
          this.disableSubmitBtn = false;
          this.videoUrl = '';
          this.title = '';
        }
      }
    }
  }
  userDetails() {
    this.service.getUserDetails(this.id).subscribe((res: any) => {
      console.log(res)
      this.name = res.firstName
      this.img = res.profilePic
      this.iamVideo=res.imVideoUrl

      if (this.img == null) {
        this.setProfilePic = true
      }
      else {
        this.setProfilePic = false
      }
      // if(this.iamVideo){
      //   this.disableBack=false;
      // }
      // else if(this.iamVideo == ''){
      //   this.disableBack=false;
      // }
      // else{
      //   this.disableBack=true;

      // }
    })

  }

  id(id: any) {
    throw new Error('Method not implemented.');
  }
  submit() {
    const data = this.OnboardingService.postSetup4(this.videoUrl, this.userId).subscribe((res) => {
      console.log(res)

    }, err => {
      console.log(err)
      if(err == 200){
        this.Router.navigate([`/userProfiles/${this.userId}`]);
        this.spinner.hide();
      }
      else if(err == 400 || 500){
        alert("something went wrong,Please try again")

        this.Router.navigate([`/userProfiles/${this.userId}/setup/4`]);
        this.spinner.hide();
        this.disableSubmitBtn = false;

      }
    })
  }

  navigateToIamvideo(){
    this.Router.navigate([`/userProfiles/${this.userId}/create/i-am-video`]);
  }
}
